/**
 * 返回顶部按钮 - 主逻辑
 * 功能：滚动超过一定距离后显示按钮，点击平滑返回顶部
 * 文件路径（Shopify）：Assets/back-to-top.js
 */

(function () {
  'use strict';

  /* ===== 创建按钮 DOM ===== */
  function createButton() {
    var btn = document.createElement('button');
    btn.className = 'back-to-top-btn';
    btn.setAttribute('aria-label', 'ページトップへ戻る');
    btn.setAttribute('title', 'ページトップへ戻る');
    btn.innerHTML = '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round"><polyline points="18 15 12 9 6 15"></polyline></svg>';
    document.body.appendChild(btn);
    return btn;
  }

  /* ===== 滚动监听 ===== */
  var btn = null;
  var isVisible = false;
  var THRESHOLD = 400; // 滚动超过 400px 后显示

  function onScroll() {
    if (!btn) return;
    var shouldShow = window.pageYOffset > THRESHOLD;
    if (shouldShow !== isVisible) {
      isVisible = shouldShow;
      btn.classList.toggle('is-visible', shouldShow);
    }
  }

  /* ===== 点击返回顶部 ===== */
  function onCLick() {
    window.scrollTo({
      top: 0,
      behavior: 'smooth'
    });
  }

  /* ===== 初始化 ===== */
  function init() {
    // 避免重复创建
    if (document.querySelector('.back-to-top-btn')) return;

    btn = createButton();
    window.addEventListener('scroll', onScroll, { passive: true });
    btn.addEventListener('click', onCLick);

    // 初次检查
    onScroll();
  }

  /* ===== 启动 ===== */
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

})();
